<template>
    <div>
        <v-card>
            <v-card-title>
                <span>{{ $t("settings.bonusTimeSlices.title") }}</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog=true">{{ $t("settings.bonusTimeSlices.new") }}</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="timeSlices" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.start_time }}</td>
                    <td class="text-xs-left">{{ props.item.end_time }}</td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("settings.bonusTimeSlices.addNewTimeSlice") }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form ref="form">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <choose-time v-model="model.start_time" :label="$t('settings.bonusTimeSlices.startTime')"/>
                                    <choose-time v-model="model.end_time" :label="$t('settings.bonusTimeSlices.endTimeLabel')"/>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import ChooseTime from "@/components/monaco/input/ChooseTime";
    import socketEventsMixin from "@/mixins/socketEventsMixin";

    export default {
        mixins: [socketEventsMixin],
        name: "Bonus Time Slices",
        title() {
            return this.$t("settings.bonusTimeSlices.title");
        },
        components: {ChooseTime, DataTable},
        data() {
            return {
                timeSlices: [],
                loading: false,
                search: '',
                dialog: false,
                model: {
                    start_time: null,
                    end_time: null
                }
            };
        },
        computed: {
            headers() {
                return [
                    {text: this.$t('settings.bonusTimeSlices.id'), value: 'id'},
                    {text: this.$t('settings.bonusTimeSlices.startTime'), value: 'start_time'},
                    {text: this.$t('settings.bonusTimeSlices.endTime'), value: 'end_time'},
                ];
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`bonus/${this.$route.params.id}`)
                    .then(res => this.timeSlices = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            save() {
                this.loading = true;
                this.model.bonus_id = this.$route.params.id;
                this.axios.post('bonus/time_slice', this.model)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", this.$t('settings.bonusTimeSlices.success'));
                    })
                    .catch(err => {
                        console.log(err);
                        window.getApp.$emit("SHOW_TOAST", err.message, "red");
                    })
                    .finally(() => this.loading = false);
            },
            detach(captain_id, name) {
                let c = confirm(this.$t('settings.bonusTimeSlices.confirmDetach', { name }));
                if (!c) {
                    return
                }
                this.loading = true;
                this.axios.delete(`bonus_package/${this.$route.params.id}/captains/${captain_id}`)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", this.$t('settings.bonusTimeSlices.success'));
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>
